<template>
    <div>
        <div v-if="!sliders.length" style="margin-top: 10px;">Nenhum slide adicionado.</div>
        <draggable v-model="sliders" tag="div" handle=".handle">
            <div
                class="bs_list"
                v-for="(item, index) in sliders"
                :key="index">

                <div class="bs_iu">
                    <fluke-imageuploader v-model="item.img" :disabled="!enabled"></fluke-imageuploader>
                </div>
                <div class="bs_content">
                    <v-text-field label="Título" v-model="item.title" :disabled="!enabled"></v-text-field>
                    <v-textarea
                        label="Descrição"
                        rows="2"
                        auto-grow
                        v-model="item.description"
                        counter
                        maxlength="300"
                        :disabled="!enabled">
                    </v-textarea>
                    <v-text-field label="Link" v-model="item.link" :disabled="!enabled"></v-text-field>
                    <a @click="remove(index)" v-if="enabled">remover item</a>
                </div>
                <div class="handle" v-if="enabled"><i class="handle material-icons">reorder</i></div>
            </div><!-- .bs_list -->
        </draggable>

        <button class="bs_add_new fluke-btn" @click="add">
            ADICIONAR
        </button>
    </div>
</template>

<script>
import ImageUploader from '../ImageUploader/ImageUploader';
import Draggable from 'vuedraggable';


export default {
    props: [ 'disabled' ],
    components: {
        'fluke-imageuploader': ImageUploader,
        'draggable': Draggable
    },
    data: function() {
        return {
            sliders: [],
            enabled: true
        }
    },
    watch: {
        sliders: function()
        {
            this.$attrs.value = this.sliders;
            this.$emit('input', this.sliders);
        },
        '$attrs.value': function()
        {
            this.sliders = this.$attrs.value;
            this.sliders = this.$attrs.value;

            setTimeout(()=>{
                if( this.sliders.length && !this.refresher )
                {
                    this.sliders[0].description += '.';
                    this.sliders[0].description = this.sliders[0].description.slice(0,-1);
                }
            },500);
        }
    },
    created()
    {
        if( this.$props.disabled === true ) this.enabled = false;
    },
    update: function()
    {
        this.$attrs.value = this.sliders;
        this.$emit('input', this.sliders);
    },
    methods: {
        add: function() {
            this.sliders.push({
                img:'',
                title:'',
                description:'',
                link:''
            });
        },
        remove: function( index ) {
            this.sliders = this.sliders.filter( ( elem, i ) => ( i != index ) );
        }
    }
}
</script>

<style lang="scss">
.bs_list {
    display: flex;
    margin-bottom: 40px;
    border-right: 15px #eee solid;
    padding-right: 10px;

    .bs_iu {
        width: 35%;
        position: relative;
        margin-right: 2%;
    }

    .bs_content {
        flex: 1;
    }
}
.bs_add_new {
    margin: 20px 0;
}
</style>


